/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_popular_disciplines_title27 = /** @type {(inputs: {}) => string} */ () => {
	return `Popular Disciplines`
};

const fr_home_popular_disciplines_title27 = /** @type {(inputs: {}) => string} */ () => {
	return `Disciplines Populaires`
};

const de_home_popular_disciplines_title27 = /** @type {(inputs: {}) => string} */ () => {
	return `Beliebte Disziplinen`
};

const es_home_popular_disciplines_title27 = /** @type {(inputs: {}) => string} */ () => {
	return `Disciplinas populares`
};

const it_home_popular_disciplines_title27 = /** @type {(inputs: {}) => string} */ () => {
	return `Discipline popolari`
};

const ar_home_popular_disciplines_title27 = /** @type {(inputs: {}) => string} */ () => {
	return `التخصصات الشعبية`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_popular_disciplines_title27 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_popular_disciplines_title27(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_popular_disciplines_title27", locale)
	if (locale === "en") return en_home_popular_disciplines_title27(inputs)
	if (locale === "fr") return fr_home_popular_disciplines_title27(inputs)
	if (locale === "de") return de_home_popular_disciplines_title27(inputs)
	if (locale === "es") return es_home_popular_disciplines_title27(inputs)
	if (locale === "it") return it_home_popular_disciplines_title27(inputs)
	return ar_home_popular_disciplines_title27(inputs)
};
export { home_popular_disciplines_title27 as "HOME_POPULAR_DISCIPLINES_TITLE" }